import React from 'react';
import { Link } from 'react-router-dom';

interface PublicBookingLayoutProps {
  children: React.ReactNode;
}

const PublicBookingLayout: React.FC<PublicBookingLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Minimal header with just the logo */}
      <header className="h-16 border-b border-border/40 bg-background/95 backdrop-blur-sm fixed top-0 left-0 right-0 z-50">
        <div className="container h-full max-w-5xl mx-auto px-4 flex items-center">
          <Link to="/" className="flex items-center space-x-2">
            <div className="h-8 w-8 rounded-lg bg-primary text-primary-foreground flex items-center justify-center font-bold text-lg">
              C
            </div>
            <span className="text-lg font-semibold">CitaLoo</span>
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 mt-16">
        {children}
      </main>
    </div>
  );
};

export default PublicBookingLayout; 